import core from 'Shared/assets/locales/es/core.json'
import partials from 'Shared/assets/locales/es/partials.json'

import constants from './constants.json'
import menuItems from './menuItems.json'
import pages from './pages.json'

export const localeEs = {
	core,
	partials,
	constants,
	pages,
	menuItems
}
